import { render, staticRenderFns } from "./ContactFieldLanguage.vue?vue&type=template&id=18b5f340&scoped=true&"
import script from "./ContactFieldLanguage.vue?vue&type=script&lang=js&"
export * from "./ContactFieldLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5f340",
  null
  
)

export default component.exports